import React, { Component } from 'react'
import L from 'leaflet'
import { CircleMarker, Popup, Polyline, Tooltip } from 'react-leaflet'
import RotatedMarker from './rotatedMarker'

const playerIcon = new L.Icon({
  iconUrl: require('./navi-arrow.png'),
  //iconUrl: require('./wind-2x.png'),
  iconSize: new L.Point(20, 20),
});

const windIcon = new L.Icon({
  iconUrl: require('./wind-2x.png'),
  iconSize: new L.Point(20, 20),
});


export default class MainPlayer extends Component {

  render() {
    const { device } = this.props;
    console.log(device)
    const CircleM = <CircleMarker center={device.pos} radius={18} />

    // Max Speed Marker
    const MaxSpeedM = device.maxSpeedPoint ? (
      <CircleMarker center={device.maxSpeedPoint.pos} radius={10} color="gold" fillColor="gold" fillOpacity={0.8}>
        <Tooltip direction="top" offset={[0, -10]} opacity={1}>
          <span>Max Speed: {device.maxSpeedPoint.speed.toFixed(2)} {this.props.unit}</span>
        </Tooltip>
      </CircleMarker>
    ) : null;

    const GpsPop = (
      <Popup direction={'top'} offset={[0, -20]} >
        <table>
          <tbody>
            <tr>
              <th>Name</th><td>{device.name}</td>
            </tr>
            <tr>
              <th>Device</th><td>{device.id}</td>
            </tr>
            <tr>
              <th>SPEED</th><td>{device.spd} {this.props.unit}</td>
            </tr>
            <tr>
              <th>VMG</th><td>{device.vmg} {this.props.unit}</td>
            </tr>
            <tr>
              <th>ANGLE</th><td>{device.ang} deg</td>
            </tr>
          </tbody>
        </table>
      </Popup>);

    const WindPop = (
      <Popup direction={'top'} offset={[0, -20]} >
        <table>
          <tbody>
            <tr>
              <th>Device</th><td>{device.id}</td>
            </tr>
            <tr>
              <th>SPEED</th><td>{device.spd} {this.props.unit}</td>
            </tr>
            <tr>
              <th>WIND</th><td>{device.windspd} m/s</td>
            </tr>
            <tr>
              <th>WIND</th><td>{device.winddir} deg</td>
            </tr>
          </tbody>
        </table>
      </Popup>);

    return (
      <span>
        <RotatedMarker
          // if position changes, marker will drift its way to new position
          //position={ deviceMap[deviceId].pos }
          position={device.pos}
          // time in ms that marker will take to reach its destination
          //duration={1000}
          icon={device.wind ? windIcon : playerIcon}
          rotationAngle={device.rotate}
          rotationOrigin={'center'}
        >

          <Tooltip className={"tooltip"} permanent={true} direction="right" offset={[5, 2]} interactive={true}>
            <div>{device.name}</div>
          </Tooltip>

          {device.wind ? WindPop : GpsPop}
        </RotatedMarker>

        {device.main && CircleM}
        {device.main && MaxSpeedM}
        {this.props.isSailing ? renderTrackLines(device.lines) : <Polyline positions={device.lines.map(l => l.pos || l)} color={'red'} />}
      </span>
    );
  }

}

function renderTrackLines(lines) {
  if (!lines || lines.length === 0) return null;

  // Handle legacy array-based lines if any (fallback to red)
  // But new lines are objects {pos, isStb}

  const segments = [];
  let currentSegment = [];
  let currentSegmentIsStb = null;

  for (let i = 0; i < lines.length; i++) {
    const pt = lines[i];
    // Normalize point
    let pos = pt.pos || pt; // Handle {pos:[lat,lng]} or [lat,lng]
    let isStb = (pt.isStb !== undefined) ? pt.isStb : true; // Default to true if undefined? Or check logic.
    if (pt.isStb === undefined && Array.isArray(pt)) isStb = false; // Fallback? Let's say default.

    if (currentSegment.length === 0) {
      currentSegment.push(pos);
      currentSegmentIsStb = isStb;
      continue;
    }

    if (isStb !== currentSegmentIsStb) {
      // Status changed. Only finish this segment if we have >1 points?
      // We add current point to close the segment to ensure continuity
      currentSegment.push(pos);

      segments.push(
        <Polyline
          key={i}
          positions={currentSegment}
          color={currentSegmentIsStb ? '#28a745' : '#dc3545'}
          weight={3}
        />
      );

      // Start next segment with this connecting point
      currentSegment = [pos];
      currentSegmentIsStb = isStb;
    } else {
      currentSegment.push(pos);
    }
  }

  // Push last segment
  if (currentSegment.length > 1) {
    segments.push(
      <Polyline
        key={'last'}
        positions={currentSegment}
        color={currentSegmentIsStb ? '#28a745' : '#dc3545'}
        weight={3}
      />
    );
  }

  return segments;
}
